import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCode, 
  faDatabase, 
  faBrain, 
  faLaptopCode 
} from '@fortawesome/free-solid-svg-icons';

const ServiceItem = ({ icon, title, features }) => (
  <div className="p-8 rounded-xl bg-white shadow-sm hover:shadow-lg transition-all">
    <div className="flex items-center justify-center mb-6">
      <div className="text-custom h-16 w-16 flex items-center justify-center bg-gray-50 rounded-full">
        <FontAwesomeIcon icon={icon} size="2x" />
      </div>
    </div>
    <h3 className="text-xl font-semibold mb-4 text-center">{title}</h3>
    <ul className="space-y-3">
      {features.map((feature, index) => (
        <li key={index} className="flex items-center gap-3">
          <FontAwesomeIcon icon={faCode} className="text-custom text-sm" />
          <span className="text-gray-600">{feature}</span>
        </li>
      ))}
    </ul>
  </div>
);

const Services = () => {
  const { t } = useTranslation();
  
  const services = [
    {
      icon: faLaptopCode,
      title: t('services.development.title'),
      features: [
        t('services.development.features.web'),
        t('services.development.features.mobile'),
        t('services.development.features.api')
      ]
    },
    {
      icon: faDatabase,
      title: t('services.dataScience.title'),
      features: [
        t('services.dataScience.features.analytics'),
        t('services.dataScience.features.ml'),
        t('services.dataScience.features.bi')
      ]
    },
    {
      icon: faBrain,
      title: t('services.ai.title'),
      features: [
        t('services.ai.features.nlp'),
        t('services.ai.features.vision'),
        t('services.ai.features.predictive')
      ]
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4">{t('services.title')}</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            {t('services.description')}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceItem key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
